module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-3 col-xs-12"
  }, [_c('sidebar', {
    attrs: {
      "show-controls": _vm.isLoggedIn()
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-sm-9 col-xs-12 content"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('animation', {
    attrs: {
      "visible": _vm.hasAnimation
    }
  }), _vm._v(" "), _c('popup-msg', {
    attrs: {
      "visible": _vm.showPopup,
      "type": _vm.popupType,
      "title": _vm.popupTitle,
      "text": _vm.popupText
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 705
// module chunks = 0